module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "rowBackgroundHomepage"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('b-container', {
    class: {
      customContainer: !_vm.noReduce
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "p-0",
    attrs: {
      "md": _vm.colWidth,
      "offset-md": (12 - _vm.colWidth) / 2
    }
  }, [(!_vm.isSmartphoneOS) ? _c('div', [_c('back-button', {
    attrs: {
      "returnUrl": _vm.returnUrl
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel21 panel-default"
  }, [(!_vm.isSmartphoneOS) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "showLargeScreenOnly formTitleBlock"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm",
    style: ({
      color: _vm.color
    })
  }, [(_vm.icon) ? _c('f7-icon', {
    staticClass: "formIcon",
    attrs: {
      "icon": _vm.icon
    }
  }) : (_vm.iconF7) ? _c('f7-icon', {
    attrs: {
      "f7": _vm.iconF7
    }
  }) : (_vm.iconFA) ? _c('f7-icon', {
    attrs: {
      "fa": _vm.iconFA
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("icon"), _vm._v(" "), _vm._t("titleContent", [_c('span', [_vm._v(_vm._s(_vm.title))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "showSmallScreenOnly formTitleBlock"
  }, [_c('h6', {
    staticClass: "content-block labelAccordionForm creationFormTitle",
    style: ({
      color: _vm.color
    })
  }, [(_vm.icon) ? _c('f7-icon', {
    staticClass: "formIcon",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconF7) ? _c('f7-icon', {
    attrs: {
      "f7": _vm.iconF7
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconFA) ? _c('f7-icon', {
    attrs: {
      "fa": _vm.iconFA
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("icon"), _vm._v(" "), _vm._t("titleContent", [_c('span', [_vm._v(_vm._s(_vm.title))])])], 2)]), _vm._v(" "), (_vm.mandatoryIndication) ? _c('div', {
    staticClass: "content-block italicMandatoryIndication"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.asterisk_obligation_label')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("pageContent")], 2), _vm._v(" "), _vm._t("underPanel")], 2)], 1), _vm._v(" "), _vm._t("footerButtons")], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e0a2fe34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0a2fe34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PageOutline.vue
// module id = 2515
// module chunks = 2